import { Col, Divider, Modal, Row, Space } from "antd";
import cx from "classnames";
import styles from "components/elements/Modal/Modal.module.css";
import EmployeeModalTable from "../table/EmployeeModalTable";
import { useTranslation } from "react-i18next";

function HolidayEmployeeCalendarModal({
    isModalOpen = false,
    className = "",
    width = 500,
    onCancel = () => { },
    handleOk = () => { },
    employeeCalendarManagement = () => { },
    setSelectedRowKeysResult = () => { },

    currentCalendar = {},
    employeeList = []
}) {
    const { t } = useTranslation()
    return (
        <Modal
            title={t("holiday.label.employee_contact")}
            open={isModalOpen}
            onOk={handleOk}
            closable={false}
            maskClosable={false}
            onCancel={() => {
                const cancelBtn = document.getElementById(
                    "year_accumulate_cancelBtn"
                );
                if (cancelBtn) {
                    cancelBtn.click();
                } else {
                    onCancel();
                }
            }}
            className={cx(styles.customStyle, className)}
            width={width}
            footer={null}

        >
            <EmployeeModalTable
                dataSource={employeeList}
                onSubmit={employeeCalendarManagement}
                onCancel={onCancel}
                setSelectedRowKeysResult={setSelectedRowKeysResult}
                currentCalendar={currentCalendar}
            />
        </Modal>
    )
}

export default HolidayEmployeeCalendarModal